'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editor", "onModeChange", "eventKey"];
import { useState, useEffect, useCallback, useRef } from 'react';
import { PopoverBodyMode } from 'rich-text-lib/constants/popover';
import VideoPopoverV2 from './VideoPopoverV2';
import { mceAttribPrefix, getVideoParamsFromHtml } from '../hsvideo/util';
import withPopoverModeState from './withPopoverModeState';
import { jsx as _jsx } from "react/jsx-runtime";
function VideoPopoverManager(props) {
  const {
      editor,
      onModeChange,
      eventKey
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [target, setTarget] = useState(null);
  const [video, setVideo] = useState({});
  const [videoAttrs, setVideoAttrs] = useState({});
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      setTarget(null);
      setVideo({});
      setVideoAttrs({});
    }
  }, []);
  useEffect(() => {
    const handleHsNodeChange = ({
      element
    }) => {
      if (!element) {
        handleRemove();
        return;
      }
      const nextVideo = getVideoParamsFromHtml(element, mceAttribPrefix);
      setVideo(nextVideo);
      if (element !== lastTarget.current) {
        onModeChange(PopoverBodyMode.PREVIEW);
        setTarget(element);
      }
    };
    editor.on(`hsNodeChange:${eventKey}`, handleHsNodeChange);
    return () => editor.off(`hsNodeChange:${eventKey}`, handleHsNodeChange);
  }, [editor, handleRemove, onModeChange, eventKey]);
  return /*#__PURE__*/_jsx(VideoPopoverV2, Object.assign({}, rest, videoAttrs, {
    editor: editor,
    open: !!target,
    target: target,
    onRemove: handleRemove,
    video: video,
    onModeChange: onModeChange
  }));
}
export default withPopoverModeState(VideoPopoverManager);